<div class="logout-container">
  <div class="panel-body">
    <h4 class="text-center">Logout Successful</h4>
    <div class="text-center">Click here to <a id="logout-to-login" class="font-weight-bold" style="color: dodgerblue; cursor: pointer;" (click)="backToLogin()">Login</a></div>
  </div>
</div>
